export default __webpack_public_path__ + "static/Step-2-e18bab38261fdf2e7be702c1353a4208.svg";